import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { retry, throwError, timer } from 'rxjs';
import { SKIP_RETRY } from './http-context-tokens';

const isTransientHttpError = (error: HttpErrorResponse): boolean =>
  error.status === 0 || error.status >= 502;

export const retryInterceptor: HttpInterceptorFn = (req, next) =>
  req.context.get(SKIP_RETRY) ? next(req) : next(req).pipe(
    retry({
      count: 2,
      delay: (error: HttpErrorResponse, retryCount) =>
        isTransientHttpError(error) ? timer(1000 * retryCount) : throwError(() => error),
    }),
  );
